/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  AtomicOperationDefinition,
  ConstantOrPerOp,
  GenericAtomicOperation,
  ScopedIdsConfig,
} from "../atomic-operations/index.js";

import type { internalHexVersionIdPayloadKey } from "./HexVersionAtomicOperation.js";

type HexVersionModelIdArg = typeof internalHexVersionIdPayloadKey;

export interface HexVersionAtomicOperationDefinitionExtras<
  CREATE extends (...args: any[]) => GenericAtomicOperation,
> {
  /**
   * If true, don't include operations of this type in edit history
   *
   * @default false
   */
  excludeFromHistory?: ConstantOrPerOp<boolean, CREATE>;
  /**
   * If true, don't include extra operations returned by
   * the server when handling operations of this type in edit history
   *
   * @default false
   */
  excludeExtraOpsFromHistory?: ConstantOrPerOp<boolean, CREATE>;
  /**
   * What every payload id of this operation is allowed to point at, relative to
   * the hexVersion the operation is applied under.
   */
  scopedIds: ScopedIdsConfig<ReturnType<CREATE>["payload"]>;
}

export type HexVersionAtomicOperationDefinition<
  CREATE extends (...args: any[]) => GenericAtomicOperation,
> = AtomicOperationDefinition<
  CREATE,
  HexVersionAtomicOperationDefinitionExtras<CREATE>,
  HexVersionModelIdArg
>;

export const createHexVersionAtomicOperationDefinition = <
  CREATE extends (...args: any[]) => GenericAtomicOperation,
>(
  baseDef: AtomicOperationDefinition<
    CREATE,
    HexVersionAtomicOperationDefinitionExtras<CREATE>,
    HexVersionModelIdArg
  >,
): AtomicOperationDefinition<
  CREATE,
  HexVersionAtomicOperationDefinitionExtras<CREATE>,
  HexVersionModelIdArg
> => baseDef;
